/** @format */

import { Component, Input, OnInit } from '@angular/core';
import {
	selectAllProductSkusPartNumber,
	selectBundleInStorePickupButtonText,
	selectBundleNearbyAvailableStoreCount,
	selectBundleProductsDataPartNumbers,
	selectNearbyAvailableStoreCount,
	selectResolvedSkuPartNumber,
	selectSelectedBundleSkusPartNumbers,
	selectStoreNameTitleCase
} from '@pdp/data-access/state';

import {
	FulfillmentButtonInterface,
	selectInStorePickupButtonText,
	selectShipMode
} from '@pdp/add-to-cart/data-access';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCrossChainBopisStoreName } from '@state/data-access';
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeStoreButtonComponent } from '../../../change-store-button/change-store-button.component';

@Component({
	selector: 'pdp-feature-in-store-pickup-subtext',
	templateUrl: './in-store-pickup-subtext.component.html',
	styleUrl: './in-store-pickup-subtext.component.scss',
	imports: [NgClass, ChangeStoreButtonComponent, AsyncPipe]
})
export class InStorePickupSubTextComponent implements OnInit {
	@Input() isBundle = false;

	productSkusPartNumber$ = this.store.select(selectAllProductSkusPartNumber);

	selectCrossChainBopisStoreName$ = this.store.select(selectCrossChainBopisStoreName);

	shipMode$ = this.store.select(selectShipMode);

	selectStoreNameTitleCase$ = this.store.select(selectStoreNameTitleCase);

	inStorePickupButtonText$: Observable<FulfillmentButtonInterface>;

	selectNearbyAvailableStores$: Observable<number>;

	resolvedSkuId$: Observable<string | string[]>;

	constructor(private store: Store) {}

	ngOnInit(): void {
		this.inStorePickupButtonText$ = this.getInStorePickupButtonTextSelector();
		this.selectNearbyAvailableStores$ = this.isBundle
			? this.store.select(selectBundleNearbyAvailableStoreCount)
			: this.store.select(selectNearbyAvailableStoreCount);
		this.productSkusPartNumber$ = this.isBundle
			? this.store.select(selectBundleProductsDataPartNumbers)
			: this.store.select(selectAllProductSkusPartNumber);
		this.resolvedSkuId$ = this.isBundle
			? this.store.select(selectSelectedBundleSkusPartNumbers)
			: this.store.select(selectResolvedSkuPartNumber);
	}

	getInStorePickupButtonTextSelector(): Observable<FulfillmentButtonInterface> {
		return this.isBundle
			? this.store.select(selectBundleInStorePickupButtonText)
			: this.store.select(selectInStorePickupButtonText);
	}
}
